import React from "react";

export const loadStyles = async (cssFileName) => {
    try {
        const existingStyle = document.getElementById(cssFileName);
        if (!existingStyle) {
            const response = await fetch(
                `${process.env.REACT_APP_CSS_URL}/${cssFileName}.min.css`
            );
            const css = await response.text();
            const style = document.createElement("style");
            style.textContent = css;
            style.id = cssFileName;
            document.head.appendChild(style);
        }
    } catch (error) {
        console.error(`Failed to load ${cssFileName} CSS:`, error);
    }
};